import { Box, Link, Typography } from '@mui/material';

interface SectionWithTitleProps {
  title: string;
  learnMoreLink?: string;
  children: string;
}

function SectionWithTitle({ title, learnMoreLink, children }: SectionWithTitleProps) {
  return (
    <Box>
      <Typography variant="h2" mb={1}>
        {title}
      </Typography>
      <Typography variant="body3" mt={1} mb={4}>
        {children}{' '}
        {learnMoreLink ? (
          <Link href={learnMoreLink} underline="always">
            Learn more
          </Link>
        ) : null}
      </Typography>
    </Box>
  );
}

SectionWithTitle.defaultProps = {
  learnMoreLink: undefined,
};

export default SectionWithTitle;
